module.exports = __webpack_public_path__ + "img/logo.02602748.svg";